import React, { useState } from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import { DS } from './ds';
import { useAuth } from '../contexts/AuthContext';
import { VerificationModal } from './VerificationModal';
interface GoogleSignInButtonProps {
  onSuccess?: () => void;
}
interface GoogleUserInfo {
  id: string;
  email: string;
  name: string;
  picture: string;
}
export const GoogleSignInButton = ({
  onSuccess
}: GoogleSignInButtonProps) => {
  const {
    setUser
  } = useAuth();
  const [showVerification, setShowVerification] = useState(false);
  const [googleUserInfo, setGoogleUserInfo] = useState<GoogleUserInfo | null>(null);
  const login = useGoogleLogin({
    onSuccess: async codeResponse => {
      try {
        const userInfo = await axios.get<GoogleUserInfo>('https://www.googleapis.com/oauth2/v1/userinfo', {
          headers: {
            Authorization: `Bearer ${codeResponse.access_token}`
          }
        });
        setGoogleUserInfo(userInfo.data);
        setShowVerification(true);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error al obtener información del usuario:', error);
      }
    },
    onError: () => {
      // eslint-disable-next-line no-console
      console.error('Login failed');
    },
    flow: 'implicit'
  });
  const handleVerificationSuccess = (email: string, name: string) => {
    if (!googleUserInfo) return;
    setUser({
      email,
      name,
      picture: googleUserInfo.picture || '',
      sub: googleUserInfo.id,
      verified: true
    });
    setShowVerification(false);
    setGoogleUserInfo(null);
    onSuccess?.();
  };
  return <>
      <button type="button" onClick={() => login()} style={{
      width: '100%',
      padding: '12px 24px',
      background: '#fff',
      color: DS.color.ink,
      border: `2px solid ${DS.color.aqua}`,
      borderRadius: '12px',
      fontFamily: DS.font.body,
      fontSize: '14px',
      fontWeight: 700,
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '10px',
      transition: `background-color 0.25s ${DS.ease.smooth}, color 0.25s ${DS.ease.smooth}`
    }} onMouseEnter={e => {
      e.currentTarget.style.background = DS.color.aqua;
      e.currentTarget.style.color = '#fff';
    }} onMouseLeave={e => {
      e.currentTarget.style.background = '#fff';
      e.currentTarget.style.color = DS.color.ink;
    }} data-id="element-79" data-mp="10g9zgwnte88">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true" data-id="element-80" data-mp="3mligv4jdldqj">
          <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" data-id="element-81" data-mp="3rjblht515zop" />
          <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" data-id="element-82" data-mp="nugqqtegieia" />
          <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" data-id="element-83" data-mp="23mkkijxm8g0o" />
          <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" data-id="element-84" data-mp="2dbc86fvn8e5s" />
        </svg>
        Inicia sesión con Google
      </button>

      {showVerification && googleUserInfo && <VerificationModal email={googleUserInfo.email} onVerify={handleVerificationSuccess} onCancel={() => {
      setShowVerification(false);
      setGoogleUserInfo(null);
    }} data-id="element-85" data-mp="1yn7y20anpaym" />}
    </>;
};